const TOKEN_KEY = 'yq_admin_token'
const SIGN_SECRET_KEY = 'yq_admin_sign_secret'
const USER_KEY = 'yq_admin_user'
const ROLES_KEY = 'yq_admin_roles'
const PERMISSIONS_KEY = 'yq_admin_permissions'

/** 与后端 PermissionInterceptor 保持一致：超级管理员角色编码 */
const SUPER_ROLE_CODES = ['SUPER_ADMIN', 'ADMIN', 'admin']

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function getSignSecret() {
  return localStorage.getItem(SIGN_SECRET_KEY) || ''
}

export function getUser() {
  try {
    const raw = localStorage.getItem(USER_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export function getRoles() {
  try {
    const raw = localStorage.getItem(ROLES_KEY)
    const list = raw ? JSON.parse(raw) : []
    return Array.isArray(list) ? list : []
  } catch (e) {
    return []
  }
}

export function getPermissions() {
  try {
    const raw = localStorage.getItem(PERMISSIONS_KEY)
    const list = raw ? JSON.parse(raw) : []
    return Array.isArray(list) ? list : []
  } catch (e) {
    return []
  }
}

export function setLoginInfo(loginRes) {
  if (!loginRes) return
  if (loginRes.token) localStorage.setItem(TOKEN_KEY, loginRes.token)
  if (loginRes.signSecret) localStorage.setItem(SIGN_SECRET_KEY, loginRes.signSecret)
  if (loginRes.userDetailRes) {
    localStorage.setItem(USER_KEY, JSON.stringify(loginRes.userDetailRes))
  }
  const roles = Array.isArray(loginRes.roles) ? loginRes.roles : []
  const permissions = Array.isArray(loginRes.permissions) ? loginRes.permissions : []
  localStorage.setItem(ROLES_KEY, JSON.stringify(roles))
  localStorage.setItem(PERMISSIONS_KEY, JSON.stringify(permissions))
}

export function clearLoginInfo() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(SIGN_SECRET_KEY)
  localStorage.removeItem(USER_KEY)
  localStorage.removeItem(ROLES_KEY)
  localStorage.removeItem(PERMISSIONS_KEY)
}

export function isLoggedIn() {
  return !!getToken() && !!getSignSecret()
}

/**
 * 登录后是否已有角色/权限缓存。
 * 权限改造前的旧会话只有 token，没有 roles/permissions，需要重新登录。
 */
export function hasAuthCache() {
  return getRoles().length > 0 || getPermissions().length > 0
}

/** 是否超级管理员（前端菜单/按钮全放行，与后端一致） */
export function isSuperAdmin() {
  const roles = getRoles()
  return SUPER_ROLE_CODES.some(code => roles.includes(code))
}

/**
 * 是否拥有指定权限码。
 * @param {string|string[]} code 单个权限码，或多个（满足其一即可）
 */
export function hasPermission(code) {
  if (!code) return true
  if (isSuperAdmin()) return true
  const permissions = getPermissions()
  if (!permissions.length) return false
  if (Array.isArray(code)) {
    return code.some(item => permissions.includes(item))
  }
  return permissions.includes(code)
}

/**
 * 是否拥有指定角色编码。
 * @param {string|string[]} code 单个角色，或多个（满足其一即可）
 */
export function hasRole(code) {
  if (!code) return true
  if (isSuperAdmin()) return true
  const roles = getRoles()
  if (!roles.length) return false
  if (Array.isArray(code)) {
    return code.some(item => roles.includes(item))
  }
  return roles.includes(code)
}
